import { render, staticRenderFns } from "./salesChangeStatistics.vue?vue&type=template&id=a2d2ad6c&scoped=true&"
import script from "./salesChangeStatistics.vue?vue&type=script&lang=js&"
export * from "./salesChangeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./salesChangeStatistics.vue?vue&type=style&index=0&id=a2d2ad6c&prod&lang=stylus&scoped=true&"
import style1 from "./salesChangeStatistics.vue?vue&type=style&index=1&id=a2d2ad6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d2ad6c",
  null
  
)

export default component.exports